import axios from 'axios';
import { useCallback, useState } from 'react';

import AuthModule from '../auth/AuthModule';

export const useContactFormular = () => {
  const [res, setRes] = useState({ data: null, error: null, isLoading: false });

  const callAPI = useCallback(async (body: any) => {
    setRes((prevState) => ({ ...prevState, isLoading: true }));
    try {
      const b2cToken = await AuthModule.getInstance().getProfileTokenRedirect();
      const result = await axios({
        method: 'POST',
        url: `${process.env.REACT_APP_BACKEND_API_URL}/contact-formular`,
        data: body,
        headers: {
          Authorization: `Bearer ${b2cToken}`,
          'Ocp-Apim-Subscription-Key': `${process.env.REACT_APP_API_KEY}`,
        },
      });
      setRes({ data: result.data, error: null, isLoading: false });
    } catch (error) {
      // continue regardless of error
    }
  }, []);
  return { res, callAPI };
};
